import Storages from 'storages'
import StorageKeys from 'enum/storages.enum';

export const getDeviceGroupId = () => {
    return Storages.MainStorage.getItem(StorageKeys.Keys.SELECTEDORGANIZATIONGROUP)
        || Storages.MainStorage.getItem(StorageKeys.Keys.ORGANIZATIONGROUP)?.[0]?.['id'];
}